import * as React from 'react'
import { styled } from '../../shared/styled-components'
import { inject } from 'mobx-react'
import { CalculatorStoreInstance } from '../../stores/CalculatorStore'

interface IProps {
  store?: CalculatorStoreInstance
}

export const VideoOverlay = inject('store')((props: IProps) => {
  return (<Container>
    <VideoContainer>
      <CloseButton onClick={() => props.store!.toggleVideo()}>SCHLIESSEN</CloseButton>
      <iframe width="1100" height="618" src="https://www.youtube.com/embed/6hVxL8f1gcQ" frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
    </VideoContainer>
  </Container>)
})

const Container = styled.div`
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const VideoContainer = styled.div`
  position: fixed;
  width: 1100px;
  height: 618px;
  top: 50%;
  left: 50%;
  margin-left: -550px;
  margin-top: -309px;
  background: white;
`

const CloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 15px;
  font-weight: bold;
  color: ${props => props.theme.primaryColor};
  cursor: pointer;
  z-index: 5;
`
